module.exports = __webpack_public_path__ + "img/oculus_hifi_9.ee071318.png";